import { I18nModule } from '@et/i18n';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { AuthRoutingModule } from './auth-routing.module';
import { PresentationalAtomsModule } from '@et/presentational/atoms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { AuthService } from './services/auth.service';
import { DualAuthInterceptor } from './oauth/dual-auth.interceptor';

/**
 * `AuthModule` is imported directly in the root `AppModule`, so any
 * `HTTP_INTERCEPTORS` registered here land in the **root** injector and
 * intercept every `HttpClient` call in the entire app. When `useBetterAuth`
 * is true the root-level `OAuthModule` interceptor handles bearer tokens;
 * registering `MsalInterceptor` as well causes it to intercept API calls
 * (e.g. `GET /self`), fail `acquireTokenSilent`, and trigger a B2C redirect.
 */
const msalInterceptorProviders = [
  { provide: MsalInterceptor, useClass: MsalInterceptor },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DualAuthInterceptor,
    multi: true,
  },
];

@NgModule({
  declarations: [
    LoginComponent,
    LoginFailedComponent,
    AuthCallbackComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SetPasswordComponent,
  ],

  imports: [
    CommonModule,
    PresentationalAtomsModule,
    FormsModule,
    ReactiveFormsModule,
    AuthRoutingModule,
    I18nModule,
    MsalModule,
  ],
  providers: [
    ...msalInterceptorProviders,
    AuthService,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AuthModule {}
